<template>
    <router-view />
</template>

<style type="text/css">
  .container {
    margin: 0 auto;
  }
</style>
